/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import Component from "@glimmer/component";
import FollowUpReason from "core/models/follow-up-reason";
import { EmberChangeset } from "ember-changeset";
let TreatmentHistoryEditionFormBreastCancerFormSurgerySection = (_class = class TreatmentHistoryEditionFormBreastCancerFormSurgerySection extends Component {
  get surgeryTypes() {
    switch (this.args.followUpReasonId) {
      case "onco-lung-cancer":
        return ["pulmonary", "cerebral", "adrenal"];
      case "onco-pancreatic-cancer":
        return ["prostatectomy", "lymph-node-dissection", "pulpectomy", "orchiectomy"];
      default:
        return ["auxiliary-cleaning", "mastectomy", "quadrantectomy", "tumorectomy", "oncoplasty", "pamectomy", "prophylactic-surgery", "enlargement", "reconstruction", "sentinel-node", "pac-installation", "prophylactic-annexectomy", "ambulatory", "hospitalisation", "external", "prostatectomy", "lymph-node-dissection", "pulpectomy", "orchiectomy"];
    }
  }
  get surgeries() {
    return this.args.changeset.get("surgerySurgeries");
  }
  onChangesetUpdate(changeset) {
    changeset.execute();
    this.setAsDirty();
  }
  setAsDirty() {
    this.args.changeset.set("surgerySurgeries", [].concat(this.surgeries));
  }
}, _applyDecoratedDescriptor(_class.prototype, "onChangesetUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangesetUpdate"), _class.prototype), _class);
export { TreatmentHistoryEditionFormBreastCancerFormSurgerySection as default };